module.exports = __webpack_public_path__ + "static/media/pack1.5b08e031.png";